import { Helmet } from 'react-helmet'

import insuranceBannerImg from '@/assets/marketing/images/insurance-banner-img.png'
import { Button } from '@/components/ui/button'
import { trackMarketingCta } from '@/lib/analytics'
import { ProductsSection } from './components/ProductsSection'
import { Reveal } from './components/Reveal'

const INDUSTRIES = [
  { name: 'Trucking', live: true },
  { name: 'Construction', live: false },
  { name: 'Home services', live: false },
  { name: 'Manufacturing', live: false },
]

export function Home() {
  return (
    <>
      <Helmet>
        <title>Financial services for the physical economy</title>
      </Helmet>
      <meta
        name="description"
        content="Cai Labs makes AI-powered financial technology for the businesses that build, move, and fix the world around us."
      />

      <section id="hero" className="mx-auto max-w-(--maxw) px-5.5 pt-24 pb-16">
        <div className="flex max-w-190 flex-col items-start gap-6">
          <Reveal className="duration-[900ms]" delay={1200}>
            <span className="eyebrow hero-eyebrow home-hero-eyebrow">Introducing Cai</span>
            <h1 className="h1-hero mt-10">
              Financial services for the <span className="text-brand-900">physical economy</span>
            </h1>
          </Reveal>
          <Reveal className="duration-[900ms]" delay={1650}>
            <p className="text-ink-500 max-w-140 text-xl leading-[1.5]">
              We make AI-powered financial technology for the businesses that build, move, and fix the world
              around us.
            </p>
          </Reveal>
        </div>

        <Reveal
          className="border-ink-200 bg-surface mt-16 flex flex-col overflow-hidden rounded-xl border duration-[900ms]"
          delay={2100}
        >
          <div className="leading-[0]">
            <img src={insuranceBannerImg} alt="" className="block h-auto w-full" />
          </div>
          <div className="flex items-center justify-between gap-8 px-10 py-8 max-md:flex-col max-md:items-start max-md:gap-6">
            <div className="flex flex-col gap-2">
              <span className="text-ink text-2xl font-extrabold tracking-[-0.01em]">
                Shop insurance for trucking
              </span>
              <p className="text-md text-ink-500">
                Commercial auto liability, cargo, physical damages quotes and more.
              </p>
            </div>
            <Button
              size="lg"
              href="/insurance"
              className="max-md:w-full max-md:text-center"
              onClick={() => trackMarketingCta('home_explore_coverages', { destination: '/insurance' })}
            >
              Explore coverages
            </Button>
          </div>
        </Reveal>
      </section>

      <section id="about" className="mx-auto max-w-(--maxw) px-5.5 py-24">
        <Reveal>
          <span className="eyebrow">About</span>
          <p className="text-ink mt-6 max-w-200 text-2xl leading-[1.5]">
            We believe AI can do a lot. But we also believe some of the most important work — making, moving,
            mending — can only be done by real people in the real world. We build tools to help them succeed.
            Our AI is designed to drive down some of their biggest costs, like insurance and fuel, and help
            them run smarter, faster, and safer.
          </p>
        </Reveal>
      </section>

      <section id="industries" className="mx-auto max-w-(--maxw) px-5.5 py-24">
        <Reveal>
          <span className="eyebrow">Industries we serve</span>
          <h3 className="h3 mt-6">Built for the physical economy</h3>
          <div className="border-ink-200 mt-12 border-t">
            {INDUSTRIES.map((industry) => (
              <div
                key={industry.name}
                className="border-ink-200 flex items-center justify-between border-b py-6"
              >
                <span className="text-2xl font-extrabold tracking-[-0.02em] max-md:text-xl">
                  {industry.name}
                </span>
                <span
                  className={[
                    "inline-flex items-center gap-2 font-mono text-xs tracking-[0.1em] uppercase before:size-2 before:rounded-full before:bg-current before:content-['']",
                    industry.live ? 'text-brand-700' : 'text-ink-400',
                  ].join(' ')}
                >
                  {industry.live ? 'Live' : 'Coming soon'}
                </span>
              </div>
            ))}
          </div>
        </Reveal>
      </section>

      <ProductsSection />
    </>
  )
}
